import React from 'react';
import { compose } from 'redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// Core components
import Checkbox from 'components/core/Checkbox';
import TextField from 'components/core/TextField';
// Custom
import { buildFormErrors, installationDeviceConstraints } from 'utils/Forms';
import { deviceDataShape } from 'constants/PropTypesShapes';
import withFormManagement from 'hocs/WithFormManagement';
import withEnterKeyManager from 'hocs/WithEnterKeyManager';

class DeviceEditForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleValidate = this.handleValidate.bind(this);
  }

  componentDidMount() {
    // We need to pass component reference to parent (= DialogItem)
    const { onRef } = this.props;
    onRef(this);
  }

  componentDidUpdate(prevProps) {
    // Check if enter key has been pressed
    const { enterPressed } = this.props;
    const { enterPressed: prevEnterPressed } = prevProps;
    if (!prevEnterPressed && enterPressed) {
      this.handleValidate();
    }
  }

  // Handlers called by parent (= DialogItem)
  handleValidate() {
    const {
      fields: { name, disabled },
      onErrorsChange, onValidate,
    } = this.props;

    const errors = buildFormErrors({ name }, installationDeviceConstraints);
    // Apply errors
    onErrorsChange(errors);

    // No error => validate form
    if (!errors) {
      onValidate({ name, disabled });
      return true;
    }
    return false;
  }

  render() {
    const {
      fields: { name, disabled }, errors,
      onFieldsChange, onKeyPress,
    } = this.props;

    return (
      <div className="row">
        <div className="col-12">
          <Checkbox
            label={<LocalizedMessage id="field.disabled" values={{ gender: 'male' }} />}
            checked={disabled}
            onChange={(checked) => onFieldsChange({ disabled: checked })}
          />
        </div>
        <div className="col-12">
          <TextField
            label={<LocalizedMessage id="field.name" />}
            errorText={_get(errors, 'name')}
            value={name}
            required
            onChange={(value) => onFieldsChange({ name: value })}
            onKeyPress={onKeyPress}
          />
        </div>
      </div>
    );
  }
}

DeviceEditForm.propTypes = {
  device: deviceDataShape.isRequired, // eslint-disable-line react/no-unused-prop-types
  fields: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onFieldsChange: PropTypes.func.isRequired,
  onErrorsChange: PropTypes.func.isRequired,
  enterPressed: PropTypes.bool.isRequired,
  onKeyPress: PropTypes.func.isRequired,
  onRef: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
};

DeviceEditForm.defaultProps = {
  errors: null,
};

const mapFieldsToProps = {
  name: {
    resourceKey: 'name',
    defaultValue: '',
  },
  disabled: {
    resourceKey: 'disabled',
    defaultValue: false,
  },
};

const mapOwnPropsToResources = (ownProps) => ({
  resourceData: ownProps.device.installation.device,
});

module.exports = compose(
  withFormManagement(mapFieldsToProps, mapOwnPropsToResources, false),
  withEnterKeyManager,
)(DeviceEditForm);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/configuration/DeviceEditForm.js